/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { OperationStatus } from "Constants/OperationStatus";
import { AppState } from "Dataflows/Reducers";
import { IOperationStatusType } from "Interfaces/IOperationStatusType";
import { IMVPRetireProfileResponse } from "Interfaces/MVP/IMVPRetireProfileResponse";

/**
 * Returns program profile.
 * @param appState
 */
export const getRetireProfile = (state: AppState): IMVPRetireProfileResponse | undefined =>
  state.mvpState.retireProfileState.retireProfile;

export const getRetireProfileOperationStatus = (state: AppState): IOperationStatusType =>
  state.mvpState.retireProfileState.operationStatus;

/**
 * Returns save status of program profile.
 * @param appState
 * @returns {boolean}
 */
export const getRetireProfileStatus = (state: AppState): boolean =>
  state.mvpState.retireProfileState.operationStatus?.update === OperationStatus.Pending;

/**
 * Returns error message program profile fails.
 * @param appState
 * @returns {string}
 */
export const getRetireProfileErrorMessage = (state: AppState): string =>
  state?.mvpState?.retireProfileState?.errorMessage || "";
